'use client';

import { useEffect, useState } from 'react';

// Floating bottom-right button that appears after the reader has scrolled
// past the first viewport-height of the article. Click smooth-scrolls to
// the top of the page.
export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const threshold = () =>
      Math.max(600, Math.floor(window.innerHeight * 0.8));
    const onScroll = () => {
      setVisible(window.scrollY > threshold());
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const onClick = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Back to top"
      style={{
        position: 'fixed',
        right: 24,
        bottom: 24,
        width: 44,
        height: 44,
        borderRadius: '50%',
        background: 'rgba(20, 18, 16, 0.65)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        border: '1px solid rgba(212, 165, 116, 0.35)',
        color: 'var(--accent)',
        cursor: 'pointer',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transform: visible ? 'translateY(0)' : 'translateY(8px)',
        transition: 'opacity 240ms ease-out, transform 240ms ease-out',
        zIndex: 100,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}
